/** Return a stock badge only when the product API supplied stock data. */
export function getProductStockStatus(product: any): boolean | null {
  if (!product || typeof product !== "object") return null;
  for (const key of ["is_in_stock", "in_stock"]) {
    if (typeof product[key] === "boolean") return product[key];
  }
  if (typeof product.stock_status === "string") {
    const status = product.stock_status.toLowerCase();
    if (["in_stock", "instock"].includes(status)) return true;
    if (["out_of_stock", "outofstock"].includes(status)) return false;
  }
  for (const key of ["free_qty", "qty_available"]) {
    if (product[key] != null && product[key] !== "") {
      const quantity = Number(product[key]);
      if (Number.isFinite(quantity)) return quantity > 0;
    }
  }
  return null;
}
